import React, { Component } from "react";
import { Container } from "reactstrap";

// import RequestManager from "../../singletons/RequestManager";
import OrderMapView from "../../components/OrderMapView/OrderMapView";
export default class DeliveryLocationTracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pickupPointLat: null,
      pickupPointLng: null,
    };
  }

  componentDidMount() {
    this.getUserProfile();
  }
  getUserProfile = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let pickupPointLat =
      storeInformation.store.pickupPoints.edges[0].node.latitude;
    let pickupPointLng =
      storeInformation.store.pickupPoints.edges[0].node.longitude;
    this.setState({
      pickupPointLat: pickupPointLat,
      pickupPointLng: pickupPointLng,
    });
  };

  render() {
    const { pickupPointLat, pickupPointLng } = this.state;
    return (
      <Container
        fluid
        style={{
          display: "flex",
          padding: 20,
          flexDirection: "row",
          height: "90vh",
          width: "99.8%",
          overflow: "hidden !important",
        }}
      >
        <OrderMapView
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAqNIsWwmxw_6_gGfZvh4OT1V09ick5s78&v=3.exp&libraries=geometry,drawing,places"
          storeLastActive={""}
          pickupPointLocation={{
            lat: pickupPointLat,
            lng: pickupPointLng,
          }}
          //   trackingToken={this.props.order.node.trackingToken}
          //   trackingUrl={this.props.order.node.trackingUrl}
          loadingElement={<div style={{ height: "90vh" }} />}
          containerElement={<div style={{ height: "90vh" }} />}
          mapElement={<div style={{ height: "90vh" }} />}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/DeliveryLocationTracking/DeliveryLocationTracking.js